/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './audit.tpl.html';
import './auditItem.tpl.html';

/**
 * Module for functions related to audit items.
 */
angular
  .module('mobile.activity.audit', [])
  .controller('MobileAuditItemCtrl', function ($scope, mobileLogFactory, logFactory) {
    $scope.auditItem = mobileLogFactory.viewInfo.currentAuditItem;

    /**
     * Provides the html content to be used for an audit event.
     *
     * @param {object} audit - An audit event.
     * @returns {string} - The html to be rendered for the event.
     */
    $scope.getAuditMessage = function (audit) {
      return logFactory.getEventType(audit);
    };
  });
